<!-- src/components/UserMenu.vue -->
<template>
  <div
    class="size-menu d-flex flex-row justify-start pr-4 w-fit align-center"
    :style="isMobile ? '' : 'position: fixed; right: 0'"
  >
    <div v-if="!isMobile" class="notification-bell mr-8">
      <v-hover>
        <img
          @click="notificationDialog = true"
          class="cursor"
          src="../assets/bell 1.svg"
        />
      </v-hover>
      <span v-if="unreadBadgeCount > 0" class="notification-badge">
        {{ unreadBadgeCount > 99 ? "99+" : unreadBadgeCount }}
      </span>
    </div>

    <div v-if="!isMobile">
      <img
        src="../assets/avtar.png"
        class="rounded-xl mr-2"
        width="32"
        height="32"
      />
    </div>

    <div v-if="!isMobile" class="d-flex flex-column d-justify-evenly user-details">
      <v-card-title class="ma-0 pa-0 elipsis">
        {{ userInfo.name }}
      </v-card-title>
    </div>

    <v-menu offset-y>
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          v-if="!isMobile"
          width="40px"
          height="40px"
          color="primary"
          dark
          v-bind="attrs"
          v-on="on"
          icon
        >
          <v-icon>mdi-chevron-down</v-icon>
        </v-btn>
        <img
          v-else
          src="../assets/avtar.png"
          class="rounded-xl mobile-avatar-activator"
          width="32"
          height="32"
          v-bind="attrs"
          v-on="on"
        />
      </template>

      <div class="d-flex align-center justify-center" style="max-width: 338px">
        <div class="mx-4">
          <img
            src="../assets/avtar.png"
            class="rounded-xl mr-2"
            width="62"
            height="52"
          />
        </div>
        <div class="pa-3">
          <p class="body-1">{{ userInfo.name }}</p>
          <p class="body-2">{{ userInfo.email }}</p>
          <p class="body-2" style="color: rgba(102, 102, 102, 1)">
            {{ userInfo.HRIS_unique_role }}
          </p>
        </div>
      </div>
    </v-menu>
    <v-dialog
      v-model="notificationDialog"
      class="cdz"
      max-width="490px"
      @click:outside="closeDialog"
    >
      <v-card width="490px" height="100vh" class="filterDialogClass">
        <v-row class="mt-4 mx-1">
          <v-col>
            <div class="pl-0 mb-2 text-body1 font-weight-bold">
              Notifications
            </div>
          </v-col>
        </v-row>
        <div class="py-4 px-1 chips-bg">
          <div class="chips-bg">
            <v-row class="justify-space-around">
              <v-chip-group
                v-model="selectedRange"
                mandatory
                active-class="active-chip"
              >
                <v-chip outlined value="today">
                  Today ({{ totalCounts.today.total }})
                </v-chip>

                <v-chip outlined value="7days">
                  Last 7 Days ({{ totalCounts.last7Days.total }})
                </v-chip>

                <v-chip outlined value="30days">
                  Last 30 Days ({{ totalCounts.last30Days.total }})
                </v-chip>
              </v-chip-group>
            </v-row>
          </div>
        </div>

        <v-row>
          <v-col cols="12" class="py-0">
            <v-card class="pt-3" elevation="0">
              <p class="ml-8" style="font-size: 14px; color: gray">
                Click On The Notification To View The Latest Update.
              </p>
              <v-tabs
                v-model="tab"
                color="#000000"
                active-class="active-tab"
                grow
                class="custom-tabs"
                @change="openIndex = null"
              >
                <v-tabs-slider></v-tabs-slider>

                <v-tab href="#tab-1">
                  Unread ({{ activeCounts.unread }})
                </v-tab>

                <v-tab href="#tab-2"> Read ({{ activeCounts.read }}) </v-tab>
              </v-tabs>

              <v-tabs-items
                v-model="tab"
                @scroll.native="handleNotificationScroll"
                class="notifications-scroll"
              >
                <!-- UNREAD TAB -->
                <v-tab-item value="tab-1">
                  <v-card flat>
                    <v-card-text>
                      <v-list three-line>
                        <template v-for="(item, index) in unreadNotifications">
                          <v-list-item :key="index">
                            <v-list-item-avatar>
                              <img src="../assets/Auto-Layout-Horizontal.svg" />
                            </v-list-item-avatar>

                            <v-list-item-content>
                              <v-list-item-title class="title-14">{{
                                item.title
                              }}</v-list-item-title>
                              <v-tooltip
                                bottom
                                max-width="320"
                                content-class="notification-tooltip"
                              >
                                <template v-slot:activator="{ on, attrs }">
                                  <v-list-item-subtitle
                                    class="subtitle-12 notification-message"
                                    v-bind="attrs"
                                    v-on="on"
                                  >
                                    {{ getSubtitle(item.message, index) }}
                                  </v-list-item-subtitle>
                                </template>
                                <span>{{ item.message || "No message" }}</span>
                              </v-tooltip>
                              <div class="subtitle-12">
                                {{ formatDate(item.createdAt) }}
                              </div>
                            </v-list-item-content>

                            <v-list-item-action
                              class="pt-2 notification-toggle"
                              @click.stop="toggle(index)"
                            >
                              <img
                                :src="
                                  openIndex === index
                                    ? require('../assets/VectorUp.svg')
                                    : require('../assets/VectorDown.svg')
                                "
                                width="18"
                                height="18"
                              />
                            </v-list-item-action>
                          </v-list-item>
                          <v-expand-transition>
                            <div
                              v-show="openIndex === index"
                              class="expanded-content"
                            >
                              <p class="ma-4">
                                {{ item.details }}
                              </p>
                            </div>
                          </v-expand-transition>

                          <!-- plain divider after each item -->
                          <v-divider :key="'d-' + index" />
                        </template>
                      </v-list>
                      <!-- Add this inside both v-tab-item, after the v-list closing tag -->
                      <div v-if="isFetchingMore" class="text-center py-3">
                        <v-progress-circular
                          indeterminate
                          size="24"
                          color="primary"
                        />
                      </div>
                      <div
                        v-if="unreadNotifications.length <= 0"
                        class="text-center"
                      >
                        <p style="font-size: 16px">You're all caught up!</p>
                        <p style="font-size: 14px">
                          You have no new notifications
                        </p>
                        <img
                          :src="require('../assets/NoNotification.svg')"
                          alt="No notifications"
                        />
                      </div>
                    </v-card-text>
                  </v-card>
                </v-tab-item>

                <!-- READ TAB -->
                <v-tab-item value="tab-2">
                  <v-card flat elevation="0">
                    <v-card-text>
                      <v-list three-line>
                        <template v-for="(item, index) in readNotifications">
                          <v-list-item :key="index">
                            <v-list-item-avatar>
                              <img src="../assets/Auto-Layout-Horizontal.svg" />
                            </v-list-item-avatar>

                            <v-list-item-content>
                              <v-list-item-title class="title-14">{{
                                item.title
                              }}</v-list-item-title>
                              <v-tooltip
                                bottom
                                max-width="320"
                                content-class="notification-tooltip"
                              >
                                <template v-slot:activator="{ on, attrs }">
                                  <v-list-item-subtitle
                                    class="subtitle-12 notification-message"
                                    v-bind="attrs"
                                    v-on="on"
                                  >
                                    {{ getSubtitle(item.message, index) }}
                                  </v-list-item-subtitle>
                                </template>
                                <span>{{ item.message || "No message" }}</span>
                              </v-tooltip>
                              <div class="subtitle-12">
                                {{ formatDate(item.createdAt) }}
                              </div>
                            </v-list-item-content>

                            <v-list-item-action
                              class="pt-2 notification-toggle"
                              @click.stop="toggle(index)"
                            >
                              <img
                                :src="
                                  openIndex === index
                                    ? require('../assets/VectorUp.svg')
                                    : require('../assets/VectorDown.svg')
                                "
                                width="18"
                                height="18"
                              />
                            </v-list-item-action>
                          </v-list-item>
                          <v-expand-transition>
                            <div
                              v-show="openIndex === index"
                              class="expanded-content"
                            >
                              <p class="ma-4">
                                {{ item.details }}
                              </p>
                            </div>
                          </v-expand-transition>

                          <!-- plain divider after each item -->
                          <v-divider :key="'d-' + index" />
                        </template>
                      </v-list>
                      <!-- Add this inside both v-tab-item, after the v-list closing tag -->
                      <div v-if="isFetchingMore" class="text-center py-3">
                        <v-progress-circular
                          indeterminate
                          size="24"
                          color="primary"
                        />
                      </div>
                      <div
                        v-if="readNotifications.length <= 0"
                        class="text-center"
                      >
                        <p style="font-size: 16px">You're all caught up!</p>
                        <p style="font-size: 14px">
                          You have no new notifications
                        </p>
                        <img
                          :src="require('../assets/NoNotification.svg')"
                          alt="No notifications"
                        />
                      </div>
                    </v-card-text>
                  </v-card>
                </v-tab-item>
              </v-tabs-items>
            </v-card>
          </v-col>
        </v-row>

        <div class="filterDialogButton">
          <v-card-actions class="px-6 pb-3">
            <v-spacer></v-spacer>
            <v-btn
              rounded
              depressed
              class="btn outline-btn font-weight-medium pa-4"
              @click="closeDialog"
              >Close</v-btn
            >
          </v-card-actions>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import MailController from "@/controllers/mailController";
import {
  getFirestore,
  collection,
  onSnapshot,
  query,
  orderBy,
  limit,
  startAfter,
  getDocs,
  where,
  getCountFromServer,
  Timestamp,
} from "firebase/firestore";
export default {
  name: "UserMenu",
  data() {
    return {
      notificationDialog: false,
      tab: "tab-1",
      lastOpenIndex: null,
      openIndex: null,
      selectedRange: "today",
      notifications: [],
      pendingReadIds: [],
      lastVisible: null, // last doc snapshot for pagination
      isFetchingMore: false,
      hasMore: true,
      pageSize: 20,
      totalCounts: {
        all: { unread: 0 },
        today: { unread: 0, read: 0, total: 0 },
        last7Days: { unread: 0, read: 0, total: 0 },
        last30Days: { unread: 0, read: 0, total: 0 },
      },
    };
  },
  computed: {
    isMobile() {
      return this.$vuetify.breakpoint.smAndDown;
    },
    activeCounts() {
      if (this.selectedRange === "today"){
        
        return this.totalCounts.today;
      } 
      else if (this.selectedRange === "7days") {
        
        return this.totalCounts.last7Days;
      }else{
        
       return this.totalCounts.last30Days;
      }
      
    },
    userInfo() {
      return this.$store.state.userInfo;
    },
    unreadBadgeCount() {
      return this.totalCounts.last30Days.unread;
    },

    filteredByRange() {
      const now = new Date();
      const sevenDaysAgo = new Date();
      sevenDaysAgo.setDate(now.getDate() - 7);
      const thirtyDaysAgo = new Date();
      thirtyDaysAgo.setDate(now.getDate() - 30);

      return this.notifications.filter((n) => {
        if (!n.createdAt?.toDate) return false;
        const createdAt = n.createdAt.toDate();
        if (this.selectedRange === "today") {
          return (
            createdAt.getDate() === now.getDate() &&
            createdAt.getMonth() === now.getMonth() &&
            createdAt.getFullYear() === now.getFullYear()
          );
        }
        if (this.selectedRange === "7days") return createdAt >= sevenDaysAgo;
        return createdAt >= thirtyDaysAgo;
      });
    },

    // Today count
    todayCount() {
      const now = new Date();

      return this.notifications.filter((n) => {
        if (!n.createdAt?.toDate) return false;

        const createdAt = n.createdAt.toDate();

        return (
          createdAt.getDate() === now.getDate() &&
          createdAt.getMonth() === now.getMonth() &&
          createdAt.getFullYear() === now.getFullYear()
        );
      }).length;
    },

    // Last 7 days count
    last7DaysCount() {
      const now = new Date();
      const sevenDaysAgo = new Date();
      sevenDaysAgo.setDate(now.getDate() - 7);

      return this.notifications.filter((n) => {
        if (!n.createdAt?.toDate) return false;
        return n.createdAt.toDate() >= sevenDaysAgo;
      }).length;
    },

    // Last 30 days count
    last30DaysCount() {
      const now = new Date();
      const thirtyDaysAgo = new Date();
      thirtyDaysAgo.setDate(now.getDate() - 30);

      return this.notifications.filter((n) => {
        if (!n.createdAt?.toDate) return false;
        return n.createdAt.toDate() >= thirtyDaysAgo;
      }).length;
    },

    // Unread
    unreadNotifications() {
      return this.filteredByRange
        .filter(
          (n) =>
            (!n.isRead || this.pendingReadIds.includes(n.id)) &&
            n.createdAt?.toDate,
        )
        .sort((a, b) => b.createdAt.toDate() - a.createdAt.toDate()); // newest first
    },

    readNotifications() {
      return this.filteredByRange
        .filter(
          (n) =>
            n.isRead &&
            !this.pendingReadIds.includes(n.id) &&
            n.createdAt?.toDate,
        )
        .sort((a, b) => b.createdAt.toDate() - a.createdAt.toDate()); // newest first
    },
  },
  methods: {
    async fetchTotalCounts() {
      const db = getFirestore();
      // const adminId = "3w2P48ClXZa9tTR70DAJAsUQmIS2";
      const adminId = this.$store.state.userInfo.id;
      const notificationsRef = collection(
        db,
        "admins",
        adminId,
        "notifications",
      );

      const now = new Date();

      const todayStart = new Date(
        now.getFullYear(),
        now.getMonth(),
        now.getDate(),
      );

      const last7Start = new Date();
      last7Start.setDate(now.getDate() - 7);

      const last30Start = new Date();
      last30Start.setDate(now.getDate() - 30);

      const [
        todayUnread,
        todayRead,
        last7Unread,
        last7Read,
        last30Unread,
        last30Read,
      ] = await Promise.all([
        getCountFromServer(
          query(
            notificationsRef,
            where("createdAt", ">=", Timestamp.fromDate(todayStart)),
            where("isRead", "==", false),
          ),
        ),
        getCountFromServer(
          query(
            notificationsRef,
            where("createdAt", ">=", Timestamp.fromDate(todayStart)),
            where("isRead", "==", true),
          ),
        ),
        getCountFromServer(
          query(
            notificationsRef,
            where("createdAt", ">=", Timestamp.fromDate(last7Start)),
            where("isRead", "==", false),
          ),
        ),
        getCountFromServer(
          query(
            notificationsRef,
            where("createdAt", ">=", Timestamp.fromDate(last7Start)),
            where("isRead", "==", true),
          ),
        ),
        getCountFromServer(
          query(
            notificationsRef,
            where("createdAt", ">=", Timestamp.fromDate(last30Start)),
            where("isRead", "==", false),
          ),
        ),
        getCountFromServer(
          query(
            notificationsRef,
            where("createdAt", ">=", Timestamp.fromDate(last30Start)),
            where("isRead", "==", true),
          ),
        ),
      ]);

      this.totalCounts.today = {
        unread: todayUnread.data().count,
        read: todayRead.data().count,
        total: todayUnread.data().count + todayRead.data().count,
      };
      this.totalCounts.last7Days = {
        unread: last7Unread.data().count,
        read: last7Read.data().count,
        total: last7Unread.data().count + last7Read.data().count,
      };
      this.totalCounts.last30Days = {
        unread: last30Unread.data().count,
        read: last30Read.data().count,
        total: last30Unread.data().count + last30Read.data().count,
      };
    },
    formatDate(timestamp) {
      if (!timestamp?.toDate) return "";

      const date = timestamp.toDate();
      const day = String(date.getDate()).padStart(2, "0");
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const year = date.getFullYear();

      let hours = date.getHours();
      const minutes = String(date.getMinutes()).padStart(2, "0");
      const ampm = hours >= 12 ? "pm" : "am";
      hours = hours % 12 || 12;

      return `${day}/${month}/${year}, ${String(hours).padStart(2, "0")}:${minutes} ${ampm}`;
    },
    async closeDialog() {
      if (this.pendingReadIds.length > 0) {
        try {
          const adminId = this.$store.state.userInfo.id;
          console.log("adminId", adminId);
          await MailController.markNotificationsAsRead(
            this.pendingReadIds,
            adminId,
          );
          console.log("Marked as read:", this.pendingReadIds);
        } catch (err) {
          console.error("Failed to mark notifications as read", err);
        } finally {
          this.pendingReadIds = [];
          await this.fetchTotalCounts();
        }
      }
      else {
          // nothing was read, skip fetchTotalCounts entirely
      }
      this.openIndex = null;
      this.notificationDialog = false;
    },
    getSubtitle(text, index) {
      if (!text) {
        return "";
      }

      if (this.openIndex === index) {
        return text; // full subtitle
      }

      return text.length > 50 ? text.slice(0, 50) + "..." : text;
    },
    // Just track IDs, don't mutate isRead locally
    toggle(index) {
      const currentList =
        this.tab === "tab-1"
          ? this.unreadNotifications
          : this.readNotifications;
      const item = currentList[index];

      // Collapse if same
      if (this.openIndex === index) {
        this.openIndex = null;
        return;
      }

      // Expand
      this.openIndex = index;

      // Just collect ID, don't mutate isRead
      if (item && !item.isRead) {
        if (!this.pendingReadIds.includes(item.id)) {
          this.pendingReadIds.push(item.id);
        }
      }
    },
    // async fetchNotifications() {
    //   const db = getFirestore();

    //   const adminId = "3w2P48ClXZa9tTR70DAJAsUQmIS2";
    //   // const adminId = this.$store.state.userInfo.id;

    //   const notificationsRef = collection(
    //     db,
    //     "admins",
    //     adminId,
    //     "notifications",
    //   );

    //   this.unsubscribe = onSnapshot(
    //     notificationsRef,
    //     (snapshot) => {
    //       console.log("Docs count:", snapshot.size);

    //       this.notifications = snapshot.docs.map((doc) => ({
    //         id: doc.id,
    //         ...doc.data(),
    //       }));

    //       console.log("Fetched:", this.notifications);
    //     },
    //     (error) => {
    //       console.error("Error:", error);
    //     },
    //   );
    // },
    async fetchNotifications() {
      const db = getFirestore();
      const adminId = this.$store.state.userInfo.id;
      const notificationsRef = collection(db, "admins", adminId, "notifications");

      this.notifications = [];
      this.lastVisible = null;
      this.hasMore = true;

      if (this.unsubscribe) {
        this.unsubscribe();
        this.unsubscribe = null;
      }

      // No where clause — avoids composite-index requirement.
      // Client-side filteredByRange handles the date window.
      const q = query(
        notificationsRef,
        orderBy("createdAt", "desc"),
        limit(this.pageSize),
      );

      this.unsubscribe = onSnapshot(
        q,
        (snapshot) => {
          if (!snapshot.empty) {
            this.lastVisible = snapshot.docs[snapshot.docs.length - 1];
          }
          this.notifications = snapshot.docs.map((doc) => ({
            id: doc.id,
            ...doc.data(),
          }));
          this.hasMore = snapshot.docs.length === this.pageSize;
        },
        (error) => {
          console.error("Notification listener error:", error);
        },
      );
    },
    async fetchMoreNotifications() {
      if (this.isFetchingMore || !this.hasMore || !this.lastVisible) return;

      this.isFetchingMore = true;

      const db = getFirestore();
      const adminId = this.$store.state.userInfo.id;
      const notificationsRef = collection(db, "admins", adminId, "notifications");

      const q = query(
        notificationsRef,
        orderBy("createdAt", "desc"),
        startAfter(this.lastVisible),
        limit(this.pageSize),
      );

      try {
        const snapshot = await getDocs(q);
        if (!snapshot.empty) {
          this.lastVisible = snapshot.docs[snapshot.docs.length - 1];
          const newNotifications = snapshot.docs.map((doc) => ({
            id: doc.id,
            ...doc.data(),
          }));
          this.notifications = [...this.notifications, ...newNotifications];
        }
        this.hasMore = snapshot.docs.length === this.pageSize;
      } catch (error) {
        console.error("Error fetching more notifications:", error);
      } finally {
        this.isFetchingMore = false;
      }
    },
    handleNotificationScroll(e) {
      const el = e.target;
      const bottomReached =
        el.scrollHeight - el.scrollTop - el.clientHeight < 50; // 50px threshold

      if (bottomReached) {
        this.fetchMoreNotifications();
      }
    },
  },
  watch: {
    notificationDialog(val) {
      if (val) {
        this.fetchNotifications();
        this.fetchTotalCounts();
      }
    },
    // When a page loads and the active tab list is still empty but more docs exist,
    // automatically fetch the next page (handles the case where all loaded docs are read).
    notifications() {
      const activeListEmpty =
        this.tab === "tab-1"
          ? this.unreadNotifications.length === 0
          : this.readNotifications.length === 0;

      if (activeListEmpty && this.hasMore && !this.isFetchingMore) {
        this.fetchMoreNotifications();
      }
    },
  },
  mounted() {
    this.fetchTotalCounts();
  },
};
</script>

<style scoped>
.custom-tabs .v-tab {
  min-height: 24px !important; /* default is 48px */
  padding-top: 0;
  padding-bottom: 0;
}

.notification-message {
  cursor: default;
}

::v-deep .notification-toggle {
  cursor: pointer;
}

::v-deep .notification-toggle img {
  cursor: pointer;
}

::v-deep .notification-tooltip::before,
::v-deep .notification-tooltip::after {
  display: none !important;
  content: none !important;
}

.notification-bell {
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
}

.mobile-avatar-activator {
  cursor: pointer;
}

.notification-badge {
  position: absolute;
  top: -5px;
  right: -10px;
  min-width: 18px;
  height: 18px;
  padding: 0 5px;
  border-radius: 999px;
  background: #E697AB;
  color: #000000;
  font-size: 10px;
  font-weight: 600;
  line-height: 18px;
  text-align: center;
  box-shadow: 0 1px 4px rgba(255, 92, 138, 0.35);
}

/* Active underline (slider) */
.custom-tabs .v-tabs-slider {
  background-color: #1976d2; /* blue */
  height: 2px;
}

/* Inactive underline */
.custom-tabs .v-tab {
  border-bottom: 2px solid #cfcfcf; /* grey */
}

/* Remove grey underline from active tab */
.custom-tabs .v-tab--active {
  border-bottom: #1976d2;
}

.grey-bg {
  background-color: #f7f7f7;
  padding: 8px;
  border-radius: 6px; /* optional, looks nicer */
}
.chips-bg {
  background-color: #f7f7f7;

  border-radius: 6px;
}
::v-deep .white-chip.v-chip {
  background-color: #ffffff !important;
}
.right-icon {
  display: block;
}
.expanded-content {
  background: #fafafa;
  font-size: 14px;
}
.title-14 {
  font-size: 14px !important;
  line-height: 1.4;
}
.subtitle-12 {
  font-size: 12px !important;
  line-height: 1.4;
  color: #6b6b6b; /* optional, looks nicer */
}
.active-tab {
  color: var(--blue-01) !important;
  /* background: var(--gray-02) !important; */
  border: none !important;
  border-bottom: 2px solid var(--blue-01) !important;
}
.notifications-scroll {
  overflow-y: auto;
  max-height: 80vh;
  padding-bottom: 80px; /* space for Close button */
  scrollbar-width: none;
}
.notifications-scroll::-webkit-scrollbar {
  display: none; /* Chrome, Edge, Safari */
}

/* Add styles for this component here if needed */
</style>
